module.exports = __webpack_public_path__ + "media/Cake_shop.134d3292.mp3";